import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

// Import environment
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdminsWalletService {

  constructor(private http: HttpClient) { }

  getAll = (params: any) => {
    return this.http.get(environment.userApiUrl + 'api/admin/user', { params })
  }

  getAllCurrentPrice = (params: any) => {
    return this.http.get(environment.walletApiUrl + 'api/admin/priceCNV', { params })
  }


getWalletDetails() {
  return this.http.get(`${environment.walletApiUrl}api/admin/getUserReport`);
}
getAdminreport= (params: any) => {
   return this.http.get(`${environment.walletApiUrl}api/admin/getAdminreport`, { params });
}
  profitHistoryAdmin = (params: any) => {
    return this.http.get(environment.userApiUrl + 'api/admin/profitHistoryAdmin', { params });
  }

getUserAssetApiList = () => {
    return this.http.get(environment.walletApiUrl + 'api/admin/getUserAssetList')
  }
    getUserAssetApiListDoc = () => {
    return this.http.get(environment.walletApiUrl + 'api/admin/getUserAssetList', { responseType: 'text' as 'json' })
  }
  
      getUserAsset = () => {
  return this.http.get(environment.spotApiUrl + '/api/admin/getUserCoinList?export=xls',{responseType: 'text' as 'json'} )
  }
  getAllDocs = (params: any) => {
    return this.http.get(environment.userApiUrl + 'api/admin/user', { params, responseType: 'text' as 'json' })
  }

  balReportDocs = () => { 
    return this.http.get(environment.walletApiUrl + 'api/admin/balance/report/export', { responseType: 'text' as 'json' })
  }

  disable2FA = (data: any) => {
    return this.http.post(environment.userApiUrl + 'api/admin/disable-2fa', data)
  }

  userActivate = (data: any) => {
    return this.http.post(environment.userApiUrl + 'api/admin/userActivate', data)
  }

  resendMailApi = (data: any) => {
    return this.http.post(environment.userApiUrl + 'api/admin/resendMail', data)
  }

  userLockApi = (data: any) => {
    return this.http.put(environment.userApiUrl + 'api/admin/user-locked', data)
  }

  deleteAccount = (data: any) => {
    return this.http.put(environment.userApiUrl + 'api/admin/user/delete', data)
  }

  getUserAssetApi = (params: any) => {
    return this.http.get(environment.walletApiUrl + 'api/admin/getUserAsset', { params })
  }

  // download api
  getUserAssetDoc = (params: any) => {
    return this.http.get(environment.walletApiUrl + 'api/admin/getUserAsset', { params, responseType: 'text' as 'json' })
  }

  getAdminWalletBinance = (token: any) => {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': token
    });

    return this.http.get(`https://userapi.credbull.in/api/admin/bi-dcx-coinvalue`, { headers })
  }

  getAdminWalletCoinDCX = (token: any) => {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': token
    });

    return this.http.get(`https://userapi.credbull.in/api/admin/dcx-coinvalue`, { headers })
  }

  getPassbookList = (params: any) => {
    return this.http.get(environment.walletApiUrl + 'api/admin/getpassbook', { params })
  }

  // passbook list downloader api
  getPassbookDocs = (params: any) => {
    return this.http.get(environment.walletApiUrl + 'api/admin/getpassbook', { params, responseType: 'text' as 'json' })
  }

  getUserPassbookList = (params: any) => {
    return this.http.get(environment.walletApiUrl + 'api/admin/userPassBookHistory', { params })
  }

  // user's passbook downloader api
  downloadDocs = (params: any) => {
    return this.http.get(environment.walletApiUrl + 'api/admin/userPassBookHistory', { params, responseType: 'text' as 'json' })
  }

  updateAsset = (data: any) => {
    return this.http.put(environment.walletApiUrl + 'api/admin/updateUserAsset', data)
  }

  getAllKyc = (params: any) => {
    return this.http.get(environment.userApiUrl + 'api/admin/userKyc', { params })
  }

  rejectKyc = (data: any) => {
    return this.http.put(environment.userApiUrl + 'api/admin/userKyc', data)
  }

  approveKyc = (data: any) => {
    return this.http.post(environment.userApiUrl + 'api/admin/userKyc', data)
  }

  // kyc downlader api
  getAllKycDocs = (params: any) => {
    return this.http.get(environment.userApiUrl + 'api/admin/userKyc', { params, responseType: 'text' as 'json' })
  }

  getSingleKyc = (id: string) => {
    return this.http.get(environment.userApiUrl + `api/admin/userKyc/${id}`)
  }

  getBank = (params: any) => {
    return this.http.get(environment.userApiUrl + 'api/admin/getBankData', { params })
  }

  findByBankId = (id: string, userId: string) => {
    return this.http.get(environment.userApiUrl + 'api/admin/getBanksingle/' + id + "/" + userId)
  }
  getAssetsDataByCoinId = (currencyId: any, params: any) => {
    return this.http.get(environment.walletApiUrl + 'api/wallet/getAssetsDataByCoinId/' + currencyId, { params })
  }

  updateBank = (data: any) => {
    return this.http.put(environment.userApiUrl + 'api/admin/updateBank', data)
  }

  deleteBank = (data: any) => {
    return this.http.post(environment.userApiUrl + 'api/admin/updateBank', data)
  }
  updateBankstatus = (data: any) => {
    return this.http.post(environment.userApiUrl + 'api/admin/updateBankstatus', data)
  }


  userLoginHistory = (params: any) => {
    return this.http.get(environment.userApiUrl + 'api/admin/userLoginHistory', { params })
  }


  getAdminmetaData = (token: any) => {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': token
    });

    return this.http.get(environment.userApiUrl + 'api/dashboard/adminWalletDashboard', { headers })
  }
  adminWalletTrxList = (token: any) => {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': token
    });

    return this.http.get(environment.userApiUrl + 'api/dashboard/adminWalletTrxList', { headers })
  }

}


